// Angular/Ionic imports
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';

// Project/local imports (absolute)
import { AdminAiTesterModule } from 'src/app/admin/admin-ai-tester/admin-ai-tester.module.js';
import { PATHS } from 'src/app/cx-home/cx-home.component';
import { AuthService } from 'src/services/auth.service';

// Project/local imports (relative)
import { EditKnowledgeBaseItemComponent } from '../../components/edit-knowledge-base-item/edit-knowledge-base-item.component';
import { FEATURES, routes } from '../../constants';

@Component({
  selector: 'app-knowledge-base-layout',
  templateUrl: './knowledge-base-layout.component.html',
  styleUrls: ['./knowledge-base-layout.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule, // Import RouterModule for routerLink
    IonicModule,
    AdminAiTesterModule, // For the modal
  ],
})
export class KnowledgeBaseLayoutComponent implements OnInit {
  // Properties moved from KnowledgeBaseComponent
  showRunQueryModal = false;
  featureEnabled = true;

  constructor(
    private modalCtrl: ModalController,
    public router: Router,
    public authService: AuthService,
    private route: ActivatedRoute, // Inject ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Logic moved from KnowledgeBaseComponent
    this.featureEnabled = !this.authService.restrictedFeatures.includes(FEATURES.KNOWLEDGE_BASE_SYNC);
  }

  // Methods moved from KnowledgeBaseComponent
  async addKnowledgeBaseSource() {
    const modal = await this.modalCtrl.create({
      component: EditKnowledgeBaseItemComponent,
      backdropDismiss: false,
      componentProps: {
        type: 'scrape-job',
      },
    });
    await modal.present();
    // Note: Refresh logic might need adjustment depending on how children communicate up
  }

  createArticle() {
    // Navigate relative to the current route
    this.router.navigate(['./articles/new'], { relativeTo: this.route });
  }

  openRunQueryModal() {
    this.showRunQueryModal = true;
  }

  onDismissRunQueryModal() {
    this.showRunQueryModal = false;
  }
}
